export enum HttpResponseCode {
    SUCCESS =  200
}

export enum PlacementGroupStatus {
    ACTIVE = 'active',
    ARCHIVED = 'archived'
}